export default __webpack_public_path__ + "static/media/D9D1D69F-FF54-434A-86A5-3624C08DEBDD_1_105_c.274405b3.jpeg";